import { CreateEnrollmentRequiredDocumentType } from "../../../types/EnrollmentRequiredDocument";
import { post } from "../../../utils/axios-config";
import { ENROLLMENT_REQUIRED_DOCUMENTS } from "../../../utils/constants";

export const createEnrollmentRequiredDocument = async (data: CreateEnrollmentRequiredDocumentType) => await post<CreateEnrollmentRequiredDocumentType, string>(ENROLLMENT_REQUIRED_DOCUMENTS, data);